import { useCallback, useRef } from "react";

import { createCodTransaction } from "./paymentsService";
import { mapCodTransaction } from "./paymentsMappers";

const useCodPayment = () => {
  const cachedRef = useRef(null);

  const ensureTransaction = useCallback(async (amount) => {
    if (cachedRef.current && cachedRef.current.amount === amount.value) {
      return cachedRef.current.transaction;
    }

    const transaction = mapCodTransaction(await createCodTransaction({ amount }));

    cachedRef.current = { amount: amount.value, transaction };

    return transaction;
  }, []);

  const reset = useCallback(() => {
    cachedRef.current = null;
  }, []);

  return { ensureTransaction, reset };
};

export default useCodPayment;
